/* Recently viewed products: the `recently_viewed` tab of
   sections/product-tabs-bento.liquid and sections/recently-viewed-bento.liquid.

   Two jobs, both on every page that loads this file:
   - record: a product page's section root carries `data-lt-viewed="<handle>"`
     (sections/main-product-bento.liquid); its handle goes to the front of
     the list in localStorage `lt-recently-viewed` (handles, newest first,
     at most MAX);
   - fill: each `[data-recently-viewed]` element (the tab panel, or the
     section) takes the list, without the
     product on screen (`data-current`), up to its `data-limit`, and fetches
     one card per handle — `/products/<handle>?section_id=recently-viewed-bento-item`
     (sections/recently-viewed-bento-item.liquid), in parallel. Cards are
     kept in sessionStorage for the visit, so the next page shows them
     without a request, per market root and currency. A handle that answers
     404 (the product was removed or unpublished) is dropped from the list;
     any other failure only skips it this time. The
     filled track becomes the shared bento carousel
     (`window.LeonartoBento.bootCarousels`, assets/product-list-bento.js)
     and `reveal()` shows what was waiting for it; with no card everything
     stays hidden.

   The fetch waits for the page's `load` and an idle moment: the section sits
   low on the page and must not compete with what is above it.

   Storage can be unavailable (private mode, blocked site data): nothing is
   recorded and the section stays hidden. */
(function () {
  if (window.LeonartoRecentlyViewed) return;
  window.LeonartoRecentlyViewed = true;

  var KEY = 'lt-recently-viewed';
  var CARDS = 'lt-recently-viewed-cards';
  var MAX = 13; // the section's largest limit, plus the product on screen

  function readList() {
    try {
      var list = JSON.parse(window.localStorage.getItem(KEY) || '[]');
      return Array.isArray(list)
        ? list.filter(function (handle) {
            return typeof handle === 'string' && handle !== '';
          })
        : [];
    } catch (error) {
      return [];
    }
  }

  function writeList(list) {
    try {
      window.localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX)));
    } catch (error) {
      /* Not recorded. */
    }
  }

  function record(handle) {
    var list = readList().filter(function (item) {
      return item !== handle;
    });
    list.unshift(handle);
    writeList(list);
  }

  function readCards() {
    try {
      return JSON.parse(window.sessionStorage.getItem(CARDS) || '{}') || {};
    } catch (error) {
      return {};
    }
  }

  function keepCard(key, html) {
    var cards = readCards();
    cards[key] = html;
    try {
      window.sessionStorage.setItem(CARDS, JSON.stringify(cards));
    } catch (error) {
      /* Full or blocked: fetched again next time. */
    }
  }

  /* '' for a product that is gone, null for a failure worth retrying. */
  function fetchCard(root, handle) {
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || '';
    var key = root + '|' + currency + '|' + handle;
    var cached = readCards()[key];
    if (typeof cached === 'string') return Promise.resolve(cached);
    var base = root.replace(/\/$/, '');
    return fetch(base + '/products/' + encodeURIComponent(handle) + '?section_id=recently-viewed-bento-item')
      .then(function (response) {
        if (response.status === 404) return '';
        if (!response.ok) return null;
        return response.text().then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var item = doc.querySelector('[data-recently-viewed-item]');
          var card = item ? item.outerHTML : '';
          if (card) keepCard(key, card);
          return card;
        });
      })
      .catch(function () {
        return null; // a network failure: skipped, not forgotten
      });
  }

  /* What the server rendered `hidden` until there are cards, by
     `data-recently-viewed-reveal`:
     - `tab`: the panel's tab button (`aria-controls` = the panel id) and
       its nav, hidden when that button was the only other one; the panel
       itself stays hidden until the tab is opened;
     - `section`: the section (the block alone in Product tabs bento);
     - none: the element itself (sections/recently-viewed-bento.liquid). */
  function reveal(element) {
    var mode = element.getAttribute('data-recently-viewed-reveal');
    if (mode === 'tab') {
      var root = element.closest('.m-product-tabs-bento');
      var button = root && element.id ? root.querySelector('[aria-controls="' + element.id + '"]') : null;
      if (!button) return;
      button.hidden = false;
      var nav = button.closest('[data-m-tabs-nav]');
      if (nav) nav.hidden = false;
      return;
    }
    var target = mode === 'section' ? element.closest('.m-section') : element;
    if (target) target.hidden = false;
  }

  function fill(section) {
    if (section.dataset.recentlyViewedInit) return;
    section.dataset.recentlyViewedInit = 'true';
    var track = section.querySelector('[data-recently-viewed-track]');
    var carousel = section.querySelector('[data-recently-viewed-carousel]');
    if (!track || !carousel || typeof DOMParser !== 'function') return;
    var root = section.getAttribute('data-root') || '/';
    var current = section.getAttribute('data-current') || '';
    var limit = Number(section.getAttribute('data-limit')) || 8;
    var handles = readList()
      .filter(function (handle) {
        return handle !== current;
      })
      .slice(0, limit);
    if (!handles.length) return;

    Promise.all(
      handles.map(function (handle) {
        return fetchCard(root, handle);
      })
    ).then(function (cards) {
      var gone = [];
      var html = '';
      cards.forEach(function (card, index) {
        if (card === '') gone.push(handles[index]);
        else if (card) html += card;
      });
      if (gone.length) {
        writeList(
          readList().filter(function (handle) {
            return gone.indexOf(handle) === -1;
          })
        );
      }
      if (!html) return;
      track.innerHTML = html;
      carousel.setAttribute('data-m-bento-carousel', '');
      reveal(section);
      if (window.LeonartoBento && typeof window.LeonartoBento.bootCarousels === 'function') {
        window.LeonartoBento.bootCarousels();
      }
    });
  }

  function whenIdle(callback) {
    var run = function () {
      if (typeof window.requestIdleCallback === 'function') window.requestIdleCallback(callback, { timeout: 2000 });
      else setTimeout(callback, 200);
    };
    if (document.readyState === 'complete') run();
    else window.addEventListener('load', run, { once: true });
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-lt-viewed]'), function (element) {
      var handle = element.getAttribute('data-lt-viewed');
      if (handle) record(handle);
    });
    var sections = document.querySelectorAll('[data-recently-viewed]');
    if (!sections.length) return;
    whenIdle(function () {
      Array.prototype.forEach.call(sections, fill);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target && event.target.querySelector && event.target.querySelector('[data-recently-viewed]');
    if (section) fill(section);
  });
})();
